import * as logger from 'universal-logger';

export const assignIfSupported = (value, options) => {
  if (!value) {
    return null;
  }
  if (options.includes(value)) {
    return value;
  }
  logger.error(`Cancel Flow Step Modelling Error: value does not match a supported option`, { value, options });
  return null;
};

export const ITEM_TYPE = {
  checkmark: 'checkmark',
  header: 'header',
  text: 'text', // default
};

export const TEXT_STYLE = {
  bold: 'bold',
  light: 'light',
  medium: 'medium',
  header: 'header',
  legalese: 'legalese',
};

export const CTA_TYPE = {
  button: 'button',
  link: 'link', // default
};

export const BUTTON_THEMES = {
  primary: 'primary', // client default
  tertiary: 'tertiary',
  danger: 'danger',
  dangerOutline: 'tertiary', // web doesnt support/use danger-outline so we will use tertiary (per design)
};
